import React from 'react';
import request from 'superagent';
import swal from 'sweetalert';

import siteBanner_img from '../assets/img/llc/sectionTopBanner.jpg';
import { ForumForm } from "../components";

import config from '../constants/config';

class ForumFormContainer extends React.Component {
  constructor() {
    super();

    this.state = {
      loading: false
    }
  }

  addThread = (data) => {
    this.setState({loading: true});
    request.post(config.apiUrl + 'addThread')
      .send(data)
      .type('form')
      .set('Accept', 'application/x-www-form-urlencoded')
      .then((res) => {
        this.setState({
          loading: false
        });

        if (res.text === "FAIL") {
          swal({
            title: "Chyba!",
            text: "Nastala chyba ve vložení dotazu!",
            icon: "error",
          });
        }
        else {
          swal({
            title: "Hotovo!",
            text: "Dotaz byl úspěšně odeslán!",
            icon: "success",
          });
          this.props.router.push("/poradna");
        }
      })
  };

  render() {
    const langs = this.props.texts.langs;

    return (
      <div className="bg-beige2">
        <div className="siteBanner newBg">
          <img src={siteBanner_img} className="siteBanner_bg"/>
          <h2 className="line">Popište svůj problém</h2>
        </div>
        <ForumForm
          addThread={this.addThread}
          loading={this.state.loading}
          langs={{
            surgery: langs.surgery,
            doctors: langs.doctors
          }}
        />
      </div>
    );
  }
}

export default ForumFormContainer;



// WEBPACK FOOTER //
// ./src/containers/ForumForm.js